import { omit, get } from 'lodash'
import { FORM_NAMES, COMPLEX_STRUCTURED_FORM_NAMES } from '../constant'

export const templatedForms = {
  [FORM_NAMES.LAAR]: ['header', 'nameplate_information', 'visual_inspection', 'doble_power_factor', 'dc_insulation_test', 'ac_leakage_test', 'footer'],
  [FORM_NAMES.HVCB]: ['header', 'cable_information', 'test_data', 'shield_continuity', 'discharge_time', 'footer'],
  [FORM_NAMES.SF6V]: ['header', 'nameplate_information', 'visual_inspection', 'operational_tests', 'test_data_1', 'test_data_2', 'test_data_3', 'test_data_4', 'test_data_5', 'footer'],
  [FORM_NAMES.DFTR]: [
    'header',
    'nameplate_information',
    'tap_changer',
    'gauge_readings_settings',
    'visual_inspection',
    'winding_insulation_tests_m_4000',
    'exciting_current_m_4000',
    'winding_insulation_test_equipment',
    'meu',
    'primary_winding_test$DFTR',
    'secondary_winding_test$DFTR',
    'winding_resistance_test_equipment',
    'transformer_turns_ratio_tests',
    'transformer_dc_insulation_resistance',
    'footer',
  ],
  [FORM_NAMES.OFTR]: [
    'header',
    'nameplate_information',
    'tap_changer',
    'gauges_reading_and_settings',
    'visual_inspection',
    'winding_insulation_tests',
    'exciting_current_m_4000',
    'primary_bushing_information',
    'secondary_bushing_information',
    'bushing_tests',
    'primary_winding_test',
    'secondary_winding_test',
    'winding_resistance_test_equipment',
    'transformer_turns_ratio_tests',
    'transformer_dc_insulation_resistance',
    'sectional_header',
    'physical_and_chemical_tests',
    'dissolved_gas_analysis',
    'footer',
  ],
}

export const complexTemplates = {
  [COMPLEX_STRUCTURED_FORM_NAMES.LVCB]: [
    { name: 'header' },
    { name: 'nameplate_information' },
    { name: 'trip_unit_information' },
    { name: 'trip_unit_settings' },
    { name: 'visual_inspection' },
    { name: 'operational_tests' },
    { name: 'insulation_resistance_pole_to_pole' },
    { name: 'insulation_resistance_across_pole' },
    { name: 'contact_resistance_test' },
    { name: 'longtime_elements' },
    { name: 'shorttime_elements' },
    { name: 'ground_fault_elements', obj: 'ground_fault_elements_1' },
    { name: 'instantaneous_elements', obj: 'instantaneous_elements_1' },
    { name: 'footer' },
  ],
  [COMPLEX_STRUCTURED_FORM_NAMES.MFOR]: [{ name: 'header' }, { name: 'nameplate_information', process: data => omit(data, ['relaySettings']) }, { name: 'relay_settings', obj: 'nameplate_information', process: data => get(data, ['relaySettings'], {}) }, { name: 'electrical_tests' }, { name: 'footer' }],
  [FORM_NAMES.PBDC]: [{ name: 'header' }, { name: 'nameplate_information' }, { name: 'visual_and_mechanical_inspection' }, { name: 'breaker_count', obj: 'breaker_count' }, { name: 'test_connection' }, { name: 'footer' }],
  [COMPLEX_STRUCTURED_FORM_NAMES.BUDC]: [{ name: 'header' }, { name: 'nameplate_information' }, { name: 'visual_inspection' }, { name: 'insulation_resistance$BUDC', obj: 'insulation_resistance' }, { name: 'leakage_current$BUDC', obj: 'leakageCurrent' }, { name: 'footer' }],
  [COMPLEX_STRUCTURED_FORM_NAMES.HVCS]: [
    { name: 'header' },
    { name: 'nameplate_information' },
    { name: 'vlf_tan_delta_a_phase', obj: 'vlfPhaseA' },
    { name: 'vlf_tan_delta_b_phase', obj: 'vlfPhaseB' },
    { name: 'vlf_tan_delta_c_phase', obj: 'vlfPhaseC' },
    { name: 'vlf_withstand' },
    { name: 'insulation_resistance' },
    { name: 'shield_continuity' },
    { name: 'discharge_time' },
    { name: 'dc_hipot_reference_tables', obj: 'discharge_time' },
    { name: 'vlf_reference_table', obj: 'discharge_time' },
    { name: 'footer' },
  ],
  [COMPLEX_STRUCTURED_FORM_NAMES.RELA_LG]: [
    { name: 'header' },
    { name: 'nameplate_information' },
    { name: 'relay_settings$RELA', obj: 'relaySettings' },
    { name: '21$RELA', obj: '21' },
    { name: '24$RELA', obj: '24' },
    { name: '25$RELA', obj: '25' },
    { name: '27$RELA', obj: '27' },
    { name: '32$RELA', obj: '32' },
    { name: '40$RELA', obj: '40' },
    { name: '46$RELA', obj: '46' },
    { name: '50$RELA', obj: '50' },
    { name: '51$RELA', obj: '51' },
    { name: '59$RELA', obj: '59' },
    { name: '67$RELA', obj: '67' },
    { name: '81$RELA', obj: '81' },
    { name: '87$RELA', obj: '87' },
    { name: 'footer' },
  ],
  [COMPLEX_STRUCTURED_FORM_NAMES.FSGR]: [
    { name: 'header' },
    { name: 'nameplate_information' },
    { name: 'visual_inspection', obj: 'visualInspection' },
    { name: 'ground_fault_relay_settings$FSGR', obj: 'groundFaultRelaySettings' },
    { name: 'electrical_tests$FSGR', obj: 'electricalTests' },
    { name: 'pickup_tests$FSGR', obj: 'pickupTests' },
    { name: 'timing_tests$FSGR', obj: 'timingTests' },
    { name: 'footer' },
  ],
  [COMPLEX_STRUCTURED_FORM_NAMES.GRCB]: [
    { name: 'header' },
    { name: 'nameplate_information' },
    { name: 'trip_unit_information' },
    { name: 'trip_unit_settings$GRCB', obj: 'trip_unit_settings' },
    { name: 'visual_inspection' },
    { name: 'insulation_resistance_pole_to_pole' },
    { name: 'insulation_resistance_across_pole' },
    { name: 'contact_resistance_test' },
    { name: 'longtime_elements' },
    { name: 'instantaneous_elements', obj: 'instantaneous_elements_1' },
    { name: 'footer' },
  ],
  [COMPLEX_STRUCTURED_FORM_NAMES.CITR]: [{ name: 'header' }, { name: 'nameplate_information' }, { name: 'visual_inspection' }, { name: 'ratio_and_polarity_tests' }, { name: 'saturation_tests' }, { name: 'insulation_resistance$CITR', obj: 'insulationResistance' }, { name: 'footer' }],
}
